<template>
  <template v-for="index in compData.message.length">*</template>
</template>

<script setup>
const props = defineProps({
  compData: {
    type: Object,
    default: {},
  },
});
</script>
